import './LandingPage.scss'
import { useHistory } from 'react-router-dom'

import LandingHeroImg from '../../assets/images/landing-hero.png'
import LandingHero2Img from '../../assets/images/landing-hero2.png'

import IconOpenPerson from '../../components/icons/IconOpenPerson'
import IconLongArrowRight from '../../components/icons/IconLongArrowRight'
import IconMoneyBillWave from '../../components/icons/IconMoneyBillWave'

const LandingPage = () => {

	const history = useHistory()

	const onSubmit = e => {
		e.preventDefault()
		console.log('onSubmit')
	}

	return (
		<div class="landing">
			<div class="hero">
				<div class="relative overflow-hidden">
					<img
						alt="Landing Hero"
						src={LandingHeroImg}
						class="hero__img w-full h-full object-cover object-center"
					/>
					<img
						src={LandingHero2Img}
						alt="Landing Hero Right"
						class="hero__img2 absolute top-2/3 right-0 z-10"
					/>
					<div class="hero__content absolute inset-0 flex items-center justify-center">
						<h1 class="text-3xl 2xl:text-7xl font-bold text-white text-center">
							WELCOME <br />
							TO PHORIATV
						</h1>
					</div>
				</div>
			</div>
			<div class="services">
				<div class="services__inner">
					<div class="container mx-auto">
						<div class="grid grid-cols-1 lg:grid-cols-3 bg-secondary">
							<div class="service p-4 2xl:p-8 text-center mb-2 lg:mb-0">
								<h4 class="text-primary text-xl 2xl:text-2xl font-bold mb-4 2xl:mb-8">
									A Place For All Your Exclusive Content
								</h4>
								<p class="block text-base 2xl:text-2xl font-light text-white 2xl:mt-9">
									Phoria hosts your images / videos private DMs. Only
									accessible after you get paid what you've want from your
									subscribers.
								</p>
							</div>
							<div class="service p-4 2xl:p-8 text-center mb-2 lg:mb-0">
								<h4 class="text-primary text-xl 2xl:text-2xl font-bold mb-4 2xl:mb-8">
									Subscription Platform With Zero Fees
								</h4>
								<div class="flex items-center justify-center space-x-2">
									<IconMoneyBillWave class="h-8 mt-1" />
									<IconLongArrowRight class="h-4 mx-8" />
									<IconOpenPerson class="h-7" />
								</div>
								<p class="block text-base 2xl:text-2xl font-light text-white 2xl:mt-9">
									We believe creators should earn more, and not feel
									cheated for their hard work.
								</p>
							</div>
							<div class="service p-4 2xl:p-8 text-center">
								<h4 class="text-primary text-xl 2xl:text-2xl font-bold mb-4 2xl:mb-8">
									A Place For All Your Exclusive Content
								</h4>
								<p class="block text-base 2xl:text-2xl font-light text-white 2xl:mt-9">
									Phoria hosts your images / videos private DMs. Only
									accessible after you get paid what you've want from your
									subscribers.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center text-base 2xl:text-2xl text-white font-bold py-3">
					Interested in using our platform?
				</div>
			</div>
			<div class="subscribe bg-primary p-7 text-center text-white">
				<div class="container mx-auto">
					<h3 class="subscribe__title text-base 2xl:text-2xl text-white mx-auto">
						<span onClick={() => history.push("/signup")} class="text-primary font-bold cursor-pointer mr-2">
							Sign up
						</span>
						to receive information. We're only allowing a few creators to
						join
						<soan class="text-primary font-bold cursor-pointer mx-2">exclusively</soan>
						before we are in open beta.
					</h3>
					<form class="mt-10 max-w-sm mx-auto" onSubmit={onSubmit}>
						<div class="subscribe__input-group mx-auto relative">
							<label for="name" class="sr-only">Name</label>
							<input
								id="name"
								type="text"
								placeholder="Enter Full Name"
								class="text-base lg:text-xl 2xl:text-2xl w-full bg-secondary text-white py-1 md:py-2 px-2 md:px-3 2xl:p-4"
							/>
						</div>
						<div class="subscribe__input-group mx-auto relative mt-2 md:mt-3 2xl:mt-4">
							<label for="email" class="sr-only">Email</label>
							<input
								id="email"
								type="email"
								placeholder="Your Email"
								class="text-base lg:text-xl 2xl:text-2xl w-full bg-secondary text-white py-1 md:py-2 px-2 md:px-3 2xl:p-4"
							/>
						</div>
						<div class="subscribe__input-group mx-auto relative mt-2 md:mt-3 2xl:mt-4">
							<label for="name" class="sr-only">Name</label>
							<input
								id="instagram"
								type="text"
								placeholder="Instagram Handle"
								class="text-base lg:text-xl 2xl:text-2xl w-full bg-secondary text-white py-1 md:py-2 px-2 md:px-3 2xl:p-4"
							/>
						</div>
						<button class="bg-yellow-accent3 lg:text-xl 2xl:text-2xl font-bold uppercase mt-2 md:mt-3 2xl:mt-4 py-1 md:py-2 px-2 md:px-3 2xl:p-4">
							Submit
						</button>
					</form>
				</div>
			</div>
		</div>
	)
}

export default LandingPage